var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhEyeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:eye-fill"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4E0AA5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 102",
    cx: 20,
    cy: 20,
    r: 6,
    fill: "#4E0AA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.9195 19.595C33.8787 19.4963 32.8905 17.1475 30.6937 14.7937C27.7665 11.6575 24.0693 10 20 10C15.9307 10 12.2335 11.6575 9.30632 14.7937C7.10949 17.1475 6.11666 19.5 6.08049 19.595C6.02742 19.7229 6 19.8613 6 20.0012C6 20.1412 6.02742 20.2796 6.08049 20.4075C6.12132 20.5062 7.10949 22.8538 9.30632 25.2075C12.2335 28.3425 15.9307 30 20 30C24.0693 30 27.7665 28.3425 30.6937 25.2075C32.8905 22.8538 33.8787 20.5062 33.9195 20.4075C33.9726 20.2796 34 20.1412 34 20.0012C34 19.8613 33.9726 19.7229 33.9195 19.595ZM20 25C19.077 25 18.1748 24.7068 17.4073 24.1573C16.6399 23.6079 16.0418 22.827 15.6886 21.9134C15.3353 20.9998 15.2429 19.9945 15.423 19.0245C15.6031 18.0546 16.0475 17.1637 16.7002 16.4645C17.3528 15.7652 18.1843 15.289 19.0896 15.0961C19.9948 14.9031 20.9331 15.0022 21.7859 15.3806C22.6386 15.759 23.3674 16.3999 23.8802 17.2221C24.393 18.0444 24.6667 19.0111 24.6667 20C24.6667 21.3261 24.175 22.5979 23.2998 23.5355C22.4247 24.4732 21.2377 25 20 25Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhEyeFill);
export default __webpack_public_path__ + "static/media/ph_eye-fill.2e5e29e75407ba54313725dc40dde94d.svg";
export { ForwardRef as ReactComponent };